import Vue from 'vue'
import axios from 'axios'
import { showNotification } from '@/services/calculate'
import moment from 'moment-timezone'

export const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  transformRequest: [
    (data, headers) => {
      headers['Authorization'] = 'Bearer ' + getToken()
      headers['Is-Archive'] = getArchieve()
      return JSON.stringify(data)
    },
  ],
  headers: {
    'Content-Type': 'application/json',
  },
})

export const instanceUpload = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  transformRequest: [
    (data, headers) => {
      headers['Authorization'] = 'Bearer ' + getToken()
      headers['Is-Archive'] = getArchieve()
      return data
    },
  ],
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})

export const getToken = () => {
  if (localStorage.getItem('okta-token-storage')) {
    const token = JSON.parse(localStorage.getItem('okta-token-storage'))
    if (token.accessToken && token.accessToken.accessToken) {
      return token.accessToken.accessToken
    } else {
      return null
    }
  } else {
    return null
  }
}

export const getArchieve = () => {
  if (sessionStorage.getItem('Is-Archive')) {
    return sessionStorage.getItem('Is-Archive')
  } else {
    return false
  }
}

export const errorService = (error, router) => {
  if (error.response) {
    switch (error.response.status) {
      case 200:
        break
      case 400:
        showNotification('error', 'Bad Request', error.response.data.message)
        break
      case 401:
        localStorage.clear()
        Vue.prototype.stopSocket()
        showNotification('error', 'Unauthorized', error.response.data.message)
        logout()
        break
      case 403:
        Vue.prototype.$route.push({ path: 'unauthorized' })
        break
      case 404:
        showNotification('error', 'Not Found', error.response.data.message)
        break
      case 500:
        showNotification(
          'error',
          'Internal Server Error',
          error.response.data.message,
        )
        break
      default:
        showNotification('error', 'Something went wrong', 'Please try again!')
        break
    }
  }
}

async function logout() {
  await Vue.prototype.$auth.logout()
  Vue.prototype.$auth.loginRedirect()
}

export const savePreviousData = data => {
  if (data === 0) {
    window.previousValue = data.toString()
  } else {
    window.previousValue = data
  }
}

export const autocomplete = (searchKey, previousKey, previousResult, url) => {
  if (searchKey === '') return []
  if (searchKey.length < 3) return []
  if (searchKey !== previousKey && searchKey.length === 3) {
    return instance.get(`${url}`)
  } else {
    if (searchKey !== '' && searchKey.length > 3) {
      return previousResult
    }
  }
}

export const dateComparator = function dateComparator(date1, date2) {
  if (moment(new Date(date1)).isSame(new Date(date2))) {
    return 0
  } else if (moment(new Date(date1)).isAfter(new Date(date2))) {
    return 1
  } else if (moment(new Date(date1)).isBefore(new Date(date2))) {
    return -1
  }
  return 0
}

export const formatCurrency = cost => {
  const settings = JSON.parse(localStorage.getItem('userSettings'))
  const currency = settings.currency
  if (cost !== undefined && cost !== '' && cost !== 'Total' && cost !== null) {
    const value = parseFloat(cost).toFixed(2)
    return new Intl.NumberFormat(currency.currencyFormate, {
      style: 'currency',
      currency: currency.currency,
    }).format(value)
  }
  if (cost === 'Total') {
    return cost
  }
}
